import React, { useState } from 'react';

import DeleteIcon from '../../assets/icons/DeleteIcon';

import Modal from '../shared/modal';
import TextInput from '../shared/TextInput';
import ColorButton from '../shared/ColorButton';

const SpecialitiesModal = ({ open, onClose, specialities = [], onCreate, onUpdate, onDelete }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const onAddClick = async () => {
    try {
      setLoading(true);
      await onCreate(name);
      setName('');
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Edit Specialities'
      className='edit-labels-modal__container'
    >
      <div className='edit-labels-modal__content'>
        <div>
          <div>
            <div className='secondary m-b-sm'>Speciality Name</div>
            <TextInput
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder='Type name here'
            />
          </div>

          <div className='d-flex flex-end m-t-lg'>
            <ColorButton
              color='blue'
              text='Add'
              onClick={onAddClick}
              disabled={loading || !name}
              loading={loading}
            />
          </div>
        </div>

        <div className='edit-labels-modal__labels-container'>
          {specialities?.length ? (
            specialities.map((item) => (
              <div key={item.id} className='d-flex space-between'>
                <div>
                  {item.name}
                </div>
                <div className='pointer'>
                  <DeleteIcon color="#F53434" fontSize='small' onClick={() => onDelete(item.id)} />
                </div>
              </div>
            ))
          ) : (
            <div className='text-center p-lg font-bold secondary'>
              No Specialities
            </div>
          )}
        </div>

        <div className='d-flex flex-end m-t-lg'>
          <ColorButton
            color='blue'
            text='Done'
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  )
};

export default SpecialitiesModal;
